document.addEventListener('DOMContentLoaded', () => {
    const promoSliders = document.querySelectorAll('.tripplePromo__wrapper');

    promoSliders.forEach(promoSlider => {
        const splide = new Splide(promoSlider, {
            arrows: false,
            pagination: false,
            gap: '16px',
            perMove: 1,
            autoWidth: true,
            mediaQuery: 'min',
            breakpoints: {
                768: {
                    destroy: true,
                }
            }
        });

        splide.mount();
    });
});